import React from "react";
import { Button, Dialog, Divider, Grid, Typography } from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";
import { useTranslation } from "react-i18next";
import "../../style.css";

const MagazineReceivingAlert = ({
  visibility,
  handleClose,
  onClickContinue,
  onClickChangePackage,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={visibility} onClose={handleClose}>
      <Grid container direction="column" className="magazine-preference-alert">
        <Typography variant="body2" className="font-weight-600">
          {t("payment.monthlyMagazineNotIncluded")}
        </Typography>
        <Typography variant="body2" className="magazine-alert-body-txt">
          {t("payment.monthlyMagazineNotIncludedNotice")}
        </Typography>
        <Grid container className="magazine-alert-warning-box">
          <WarningIcon className="magazine-alert-warning-icon" />
          <Grid xs container direction="column" className="row-gap-4">
            <Typography variant="body2" className="font-weight-600">
              {t("common.notice")}
            </Typography>
            <Typography variant="body2">
              {t("payment.magazinePreferenceDisabledNotice")}
            </Typography>
          </Grid>
        </Grid>
        <Divider style={{ width: "100%" }} />
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          wrap="nowrap"
          className="column-gap-8 margin-top-8"
        >
          <Button
            variant="outlined"
            className="change-package-btn"
            onClick={onClickChangePackage}
          >
            <Typography variant="caption" className="font-weight-600">
              {t("payment.changePackage")}
            </Typography>
          </Button>
          <Button
            variant="contained"
            className="continue-package-btn"
            onClick={onClickContinue}
          >
            <Typography variant="caption" className="font-weight-600">
              {t("payment.continueAnyway")}
            </Typography>
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default MagazineReceivingAlert;
